import React from "react";

const Footer = () => {
  return (
    <footer className="footer w-100 text-center py-2 mt-4" style={{ backgroundColor: "#1c246b", color: "white" }}>
      <p style={{ fontSize: "0.8rem", margin: 0 }}>© {new Date().getFullYear()} YPO Emissions App. All rights reserved. 
      <img
        src="https://ypo.wpenginepowered.com/wp-content/themes/ob-ypo/images/YPO_logo-white.png"
        alt="YPO Logo"
        style={{ height: "20px", objectFit: "contain" }}
      />
      </p>      
    </footer>
  );
};

export default Footer;